// Локализация по ключам. Язык хранится в localStorage ('csi_lang').
// translate(key) -> строка на выбранном языке; fallback: en -> сам ключ.
// Русский по умолчанию заменён на английский. Словари — в lang_en/ru/uz.js.
import en from "./lang_en";
import ru from "./lang_ru";
import uz from "./lang_uz";
import configs from "./config";

const dicts = { en, ru, uz };

export const LANGS = [
  { code: "ru", label: "Рус" },
  { code: "uz", label: "Uzb" },
  { code: "en", label: "Eng" },
];

export const getLang = () => localStorage.getItem("csi_lang") || "en";

// Сохранить язык в аккаунт пользователя (если залогинен).
const persistLangToAccount = (code) => {
  const token = localStorage.getItem("csi_access_token");
  const base = configs.BASE_URL_AUTO || "";
  if (!token || !base) return Promise.resolve();
  return fetch(base + "/users/account/update_ui_prefs/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "JWT " + token,
    },
    body: JSON.stringify({ ui_language: code }),
  }).catch(() => {});
};

export const setLang = async (code) => {
  localStorage.setItem("csi_lang", code);
  await Promise.race([
    persistLangToAccount(code),
    new Promise((r) => setTimeout(r, 1500)),
  ]);
  window.location.reload();
};

// Применить язык из настроек аккаунта при входе. true, если нужен reload.
export const applyAccountLang = (uiLanguage) => {
  if (!uiLanguage) return false;
  if (localStorage.getItem("csi_lang") === uiLanguage) return false;
  localStorage.setItem("csi_lang", uiLanguage);
  return true;
};

export const translate = (key) => {
  const l = getLang();
  const d = dicts[l] || {};
  if (d[key] != null) return d[key];
  if (en[key] != null) return en[key];
  return key;
};
